import angular from 'angular';
import component from './bulk-edit-modal.component';

export default angular
    .module('dt.components.organization-alert-config.contact-groups.bulk-edit-modal', [])
    .component('bulkEditModal', component)
    .name; 